module.exports = __webpack_public_path__ + "static/media/pdf.e05ffecc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdf.png
// module id = 72
// module chunks = 0